module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/messaging_mobile-e99f8e3a917ac86b0c80ed543ee4352c.png";